<template>
  <layout-main-inner
    v-loading="loading"
    :title="$route.meta.name">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增合作企业
      </el-button>
      <!-- <el-dropdown>
        <el-button
          type="info"
          style="margin-left: 10px;">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadtmp">
            下载模板
          </el-dropdown-item>
          <el-dropdown-item @click.native="uploadtmp">
            批量上传
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入企业名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          fixed="left"
          label="企业名称"
          min-width="180"
          prop="vendorName"> </el-table-column>
        <el-table-column
          label="企业简称"
          min-width="80"
          prop="vendorShortname"> </el-table-column>
        <el-table-column
          label="企业标签"
          min-width="180"
          prop="labelName">
        </el-table-column>
        <el-table-column
          label="经营范围"
          prop="businessName"
          min-width="180"></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :width="110">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateExtraInfo(row)">编辑</el-button>
            <!-- <el-button
              type="text"
              @click="updateExtraInfo(row)">编辑</el-button> -->
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="updateExtraInfo(row)">编辑信息</el-dropdown-item>
                <el-dropdown-item @click.native="updateCertificate(row)">资质证书管理</el-dropdown-item>
                <el-dropdown-item @click.native="navigateTo(row)">查看详情</el-dropdown-item>
                <el-dropdown-item @click.native="deleteitem(row)">删除企业</el-dropdown-item>
                <!-- <el-dropdown-item
                  v-if="row.vendorBindWxapp === 0"
                  @click.native="addStaff(row)">设置管理员</el-dropdown-item> -->
                <!-- <el-dropdown-item
                  v-if="row.memberFlag === 0"
                  @click.native="setMemberFlag(row)">设为三衢味企业</el-dropdown-item> -->
                <!-- <template v-if="row.memberFlag === 1"> -->
                <!-- <el-dropdown-item @click.native="setMemberFlag(row)">设为普通企业</el-dropdown-item> -->
                <!-- <el-dropdown-item @click.native="updateExtraInfo(row)">扩展信息维护</el-dropdown-item> -->
                <!-- </template> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
    <!-- <edit-vendor-modal
      ref="edit"
      :callback="fetchList" /> -->
    <!-- <edit-staff-modal
      ref="staff"
      :callback="fetchList" /> -->
    <!-- <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest">
      <i ref="upload"></i>
    </el-upload> -->
    <!-- <upload-new
      ref="uploadNew"
      :callback="uploadWordCallback" /> -->
    <!-- <el-link
      ref="link"
      type="primary"
      style="display:none;"
      :underline="false"
      :href="surveyFormFile"
      target="_blank"
      rel="noopener noreferrer">{{ surveyFormFile }}</el-link> -->

    <edit-vendor-extra-modal
      ref="extra"
      @fetch="fetchList" />
    <!-- <vendor-inviter-select-modal
      ref="invite"
      @fetch="fetchList" /> -->
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import UploadNew from '../../../components/upload-new.vue'
// import EditStaffModal from '../edit-staff-modal.vue'
// import EditVendorModal from '../edit-vendor-modal.vue'
import EditVendorExtraModal from './edit-vendor-extra-modal.vue'
// import VendorInviterSelectModal from './vendor-inviter-select-modal.vue'
import Common from '@/service/common'
export default {
  name: 'VendorList',
  components: { EditVendorExtraModal },
  props: {
    memberFlag: { type: Number }
  },
  data() {
    return {
      loading: true,
      // totalApplys: 0,
      list: [],
      total: 0,
      // deleteable: process.env.NODE_ENV,
      // surveyFormFile: '',
      download: '',
      config: { pageNum: 1, pageSize: 10, vendorName: '' }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.fetchList()
    // this.getapplyvendors()
  },
  methods: {
    // setInviter(row) {
    //   const { vendorId, vendorName } = row
    //   this.$refs.invite.fetch({ vendorId, vendorName })
    // },
    navigateTo(row) {
      this.$router.push({ path: '/member-vendor-detail', query: { vendorId: row.vendorId }})
    },
    updateCertificate(row) {
      const { vendorName, vendorId } = row
      this.$router.push({ path: '/certificate', query: { vendorName, vendorId }})
    },
    // addStaff(row) {
    //   this.$refs.staff.update({ orgId: row.vendorId, vendorName: row.vendorName })
    // },
    // downloaditem(row) {
    //   this.surveyFormFile = row.surveyFormFile.split('?')[0]
    //   this.download = row.surveyFormFile.split('originalfilename')[1].slice(1)
    //   this.$nextTick(() => {
    //     this.$refs.link.$el.click()
    //   })
    // },
    // uploadWord(row) {
    //   this.$refs.uploadNew.upload({ vendorId: row.vendorId })
    // },
    // uploadWordCallback(options, surveyFormFile) {
    //   console.log(options, surveyFormFile)
    //   this.loading = true
    //   this.$store.dispatch(`account/updatevendor`, {
    //     payload: { ...options, surveyFormFile },
    //     success: () => {
    //       this.$message.success('更新成功')
    //       this.loading = false
    //       this.fetchList()
    //     },
    //     fail: () => {
    //       this.loading = false
    //     }
    //   })
    // },
    // downloadtmp() {
    //   this.loading = true
    //   this.$store.dispatch('account/getvendoruploadtemplate', {
    //     payload: {},
    //     success: () => {
    //       this.loading = false
    //     },
    //     fail: () => {
    //       this.loading = false
    //     }
    //   })
    // },
    // handleHttpRequest(file) {
    //   const formData = new FormData()
    //   formData.append('file', file.file)
    //   this.loading = true
    //   this.$store.dispatch('account/uploadvendor', {
    //     payload: formData,
    //     success: () => {
    //       this.loading = false
    //       this.$message.success('上传成功')
    //       this.$refs.elUpload.clearFiles()
    //       this.fetchList()
    //     },
    //     fail: () => {
    //       this.$refs.elUpload.clearFiles()
    //       this.loading = false
    //     }
    //   })
    // },
    // uploadtmp() {
    //   this.$refs.upload.click()
    // },
    additem() {
      this.$refs.extra.init()
    },
    // updateitem(row) {
    //   // this.$router.push(`/editvendor?vendorId=${row.vendorId}`)
    //   const { vendorId, vendorName, adminAccount, unifiedCreditCode, businessLicenceFile, vendorAddress, vendorPerson, vendorPhone, provinceCode, cityCode, areaCode } = row
    //   const LicenceFile = businessLicenceFile ? [{ url: businessLicenceFile }] : []
    //   const area = [provinceCode, cityCode, areaCode]
    //   this.$refs.edit.update({ vendorId, vendorName, adminAccount, unifiedCreditCode, businessLicenceFile: LicenceFile, area, vendorAddress, vendorPerson, vendorPhone })
    // },
    updateExtraInfo(row) {
      const { vendorId, vendorName, coverImage, descImages, vendorDesc, vendorShortname, labels, companyBusinessCategorys } = row
      this.$refs.extra.init({
        vendorDesc, vendorShortname, vendorId, vendorName, labels: labels || [], companyBusinessCategorys: companyBusinessCategorys || [],
        coverImage: this.$splitImage(coverImage),
        descImages: this.$splitImage(descImages)
      })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该企业?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Common.deletevendor({ vendorId: row.vendorId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    // setMemberFlag(row) {
    //   const title = row.memberFlag === 1 ? '潜在客户' : '合作企业'
    //   this.$confirm(`您确定该企业设置为${title}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
    //     .then(() => {
    //       this.loading = true
    //       this.$store.dispatch('account/updatevendor', {
    //         payload: { vendorId: row.vendorId, memberFlag: +(!row.memberFlag) },
    //         success: () => {
    //           this.loading = false
    //           this.handleCurrentChange(1)
    //           this.$message.success('设置成功')
    //         },
    //         fail: () => {
    //           this.loading = false
    //         }
    //       })
    //     })
    // },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Common.getvendors({ memberFlag: this.memberFlag, ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0].includes(result)) {
            this.total = total
            this.list = records.map(i => ({ ...i, labelName: (i.labels || []).join('，'), businessName: (i.companyBusinessCategorys || []).join('，') }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
